import qz from 'qz-tray';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const HOST_KEY = 'qz_tray_host';

export const getQzHost = () => localStorage.getItem(HOST_KEY) || 'localhost';
export const setQzHost = (host) => localStorage.setItem(HOST_KEY, host.trim() || 'localhost');

qz.security.setCertificatePromise((resolve, reject) => {
  axios.get(`${API}/print/qz-certificate`, { responseType: 'text' }).then((r) => resolve(r.data)).catch(reject);
});
qz.security.setSignatureAlgorithm('SHA512');
qz.security.setSignaturePromise((toSign) => (resolve, reject) => {
  axios.post(`${API}/print/qz-sign`, { request: toSign }, { withCredentials: true, responseType: 'text' })
    .then((r) => resolve(r.data)).catch(reject);
});

const connect = async () => {
  if (qz.websocket.isActive()) return;
  try {
    await qz.websocket.connect({ host: getQzHost(), retries: 1, delay: 1 });
  } catch (e) {
    throw new Error(`Can't reach QZ Tray at "${getQzHost()}". Make sure QZ Tray is installed and running on this device.`);
  }
};

// job = { printer: {ip_address, port, name}, data: base64 ESC/POS }
const sendRaw = async (job) => {
  await connect();
  const config = qz.configs.create({ host: job.printer.ip_address, port: job.printer.port || 9100 });
  try {
    await qz.print(config, [{ type: 'raw', format: 'command', flavor: 'base64', data: job.data }]);
  } catch (e) {
    throw new Error(`Printer ${job.printer.name || ''} (${job.printer.ip_address}) didn't respond: ${e?.message || e}`);
  }
  return job.printer;
};

export const printJob = sendRaw;

export const printStockTakeSheet = async (payload) => {
  const { data } = await axios.post(`${API}/print/stock-take-sheet`, payload, { withCredentials: true });
  return sendRaw(data);
};

export const printSavedStockTake = async (id) => {
  const { data } = await axios.get(`${API}/print/stock-takes/${id}/escpos`, { withCredentials: true });
  return sendRaw(data);
};

export const printParList = async (branchId, supplierId) => {
  const { data } = await axios.get(`${API}/print/par-grid/escpos`, { withCredentials: true, params: { branch_id: branchId, ...(supplierId ? { supplier_id: supplierId } : {}) } });
  return sendRaw(data);
};

export const printOrder = async (orderId) => {
  const { data } = await axios.get(`${API}/print/orders/${orderId}/escpos`, { withCredentials: true });
  return sendRaw(data);
};

export const printTestPage = async (printerId) => {
  const { data } = await axios.get(`${API}/print/printers/${printerId}/test-escpos`, { withCredentials: true });
  return sendRaw(data);
};

export const printSample = async (layout, printerId) => {
  const { data } = await axios.post(`${API}/print/layout-preview`, { layout, printer_id: printerId }, { withCredentials: true });
  return sendRaw(data);
};

export const checkQzConnection = async () => {
  await connect();
  return qz.api.getVersion();
};

export const qzErrorMessage = (e) => e?.response?.data?.detail || e?.message || 'Print failed';
